export default (name: string): string => `Copy of ${name.substring(0, 247)}`
